import { v1 as uuid } from 'uuid';

interface IJob {
  id: string;
  intervalSeconds: number;
  handler: (counter: number) => void;
  addedOnCounter: number;
}
export class IntervalWorkerService {
  constructor() {
    this.jobs = [];
    this.isPaused = false;
    this.interval = setInterval(() => {
      this.onInterval();
    }, 1000);
    this.counter = 0;
  }

  counter: number;

  isPaused: boolean;

  jobs: IJob[];

  interval: NodeJS.Timeout;

  addJob(id: string | undefined, onInterval: (counter: number) => void, intervalDurationSeconds = 1, executeImmediately = true) {
    const entry = {
      id: id || uuid(),
      handler: onInterval,
      intervalSeconds: intervalDurationSeconds,
      addedOnCounter: this.counter,
    };
    const existingIdx = this.jobs.findIndex((x) => x.id === entry.id);
    if (existingIdx > -1) {
      this.jobs[existingIdx] = entry;
    } else {
      this.jobs.push(entry);
    }
    if (executeImmediately) {
      onInterval(this.counter);
    }
    return entry.id;
  }

  removeJob(id: string) {
    const idx = this.jobs.findIndex((x) => x.id === id);
    if (idx > -1) {
      this.jobs.splice(idx, 1);
    }
  }

  removeAllJobs() {
    this.jobs = [];
  }

  pause() {
    this.isPaused = true;
  }

  resume() {
    this.isPaused = false;
  }

  private onInterval() {
    if (this.isPaused) {
      return;
    }
    this.counter++;
    const currentJobs = this.jobs.filter((ls) => (this.counter - ls.addedOnCounter) % ls.intervalSeconds === 0);
    for (let i = 0; i < currentJobs.length; i++) {
      currentJobs[i].handler(this.counter);
    }
  }
}
